module.exports = __webpack_public_path__ + "static/img/handle-bg.325a3e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/handle-bg.png
// module id = mncE
// module chunks = 3